import { Injectable } from '@angular/core';
import {
  CommonUtils,
  DataModel,
  RestService,
  RestSettings,
} from '@infodata-group/inf-commons';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomRestService extends RestService {
  public override options(
    api: string,
    settings?: RestSettings,
  ): Observable<DataModel> {
    return super.options(api, settings).pipe(
      map((model) => {
        model.properties.forEach((property) => {
          if (property.formGroup) {
            property.formGroup = `i18n.form.group.${CommonUtils.normalize(
              property.formGroup.replace(/\./g, '').replace(/ /g, '-'),
              true,
            )}`;
          }
        });
        return model;
      }),
    );
  }
}
